<template>
  <div id="Record">
    <div class="Record_boxs">
      <!-- <div> -->
      <div class="Record_box">
        <!-- <el-tabs v-model="activeName">
        <el-tab-pane label="账号注册" name="first"></el-tab-pane>
        </el-tabs>-->
        <div class="top" :style="type == 1 ? 'margin-top: 30%;' : ''">
          <div class="top_box">
            <span></span>
            <span style="margin-left: -10px"></span>
          </div>

          {{ type == 1 ? "修改密码" : "账号注册" }}
          <div class="top_box1">
            <span></span>
            <span style="margin-left: -10px"></span>
          </div>
        </div>
        <InputOne
          v-if="type != 1"
          name="企业名称"
          class="InputOne"
          v-model="record.name"
          field="name"
          @changeVal="inputValcall"
          reg="empty"
          :error="nameserror"
        />
        <InputOne
          v-if="type != 1"
          name="行业"
          class="InputOne"
          v-model="record.trade"
          field="trade"
          @changeVal="inputValcall"
          reg="empty"
          :error="tradeserror"
        />
        <div class="selectbox" v-if="type != 1">
          <span>企业类型</span>
          <el-select v-model="record.enterprisetype">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <InputOne
          v-if="type != 1"
          name="联系人"
          class="InputOne"
          v-model="record.Contacts"
          field="Contacts"
          @changeVal="inputValcall"
          reg="empty"
          :error="Contactsserror"
        />
        <InputOne
          v-if="type != 1"
          name="企业电话"
          class="InputOne"
          v-model="record.Enterprisephone"
          field="Enterprisephone"
          @changeVal="inputValcall"
          :isMust="false"
        />
        <div class="selectbox" v-if="type != 1">
          <span>企业规模</span>
          <el-select v-model="record.enterprisescale">
            <el-option
              v-for="item in scale"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <!-- <InputOne name="企业人数" :isMust="false" class="InputOne" /> -->
        <InputOne
          v-if="type != 1"
          name="企业地址"
          :isMust="false"
          class="InputOne"
          autocomplete="off"
          v-model="record.Enterpriseaddress"
          field="Enterpriseaddress"
          @changeVal="inputValcall"
        />
        <InputOne
          name="手机号"
          class="InputOne"
          v-model="record.phone"
          field="phone"
          @Blur="Blurphone"
          @changeVal="inputValcall"
          reg="integer"
          :error="phoneserror"
        />
        <InputOne
          auto-complete="new-password"
          :name="type == 1 ? '重置密码' : '密码'"
          class="InputOne backgroundfff"
          v-model="record.Password"
          field="Password"
          @changeVal="inputValPassword"
          password
          reg="empty"
          @Blur="Blur1"
          :error="Passwordserror"
        />
        <InputOne
          name="确认密码"
          class="InputOne backgroundfff"
          v-model="record.Confirmpassword"
          field="Confirmpassword"
          password
          @changeVal="inputValPassword"
          reg="empty"
          :error="Confirmpasswordserror"
          @Blur="Blur"
        />

        <div class="InputOne_one">
          <InputOne
            name="验证码"
            class="InputOnes"
            v-model="record.VerificationCode"
            field="VerificationCode"
            @changeVal="inputValcall"
            reg="empty"
            :error="VerificationCodeserror"
          />
          <el-button
            type="primary"
            @click="verifyCodeName"
            :disabled="disabled"
            >{{ verifyCode }}</el-button
          >
        </div>
        <div class="clickbtn">
          <a @click="loginGoRegister">已有账号前往登录</a>

          <el-button v-if="type == 0" type="primary" @click="handleLogin"
            >注册</el-button
          >
          <el-button
            v-else-if="type == 1"
            type="primary"
            @click="handlepassword"
            >修改密码</el-button
          >
          <!-- <p class="p">服务热线 : 028-84210089 69868811</p> -->
        </div>
        <div class="Record_list">
          <ul>
            <li
              :index="index + 1 + ''"
              v-for="(obj, index) in list"
              :key="index"
            >
              <p>
                <img :src="obj.img" alt />
                <span @click="ahkjhkj(obj.path)">{{ obj.text }}</span>
              </p>
            </li>
          </ul>
        </div>
      </div>
      <!-- </div> -->
      <div class="footer">版权所有 @ 成都升通达软件有限公司</div>
    </div>
  </div>
</template>

<script>
// import InputOne from "@/components/base/InputOne/InputOne.vue";

import { MD5 } from "../../utils/md5";
export default {
  components: {
    // InputOne
  },
  data() {
    return {
      type: "0",
      list: [
        {
          img: require("../../assets/images/home.png"),
          text: "进入官网",
          path: "http://www.sdasoft.com.cn",
        },
        {
          img: require("../../assets/images/lianxiwomen.png"),
          text: "联系我们",
          path: "http://www.sdasoft.com.cn/shengda/contact/",
        },
        {
          img: require("../../assets/images/yun.png"),
          text: "服务热线 : 028-84210089 69868811",
        },
      ],
      nameserror: "", // 企业名字
      tradeserror: "", // 行业
      Contactsserror: "", //  联系人
      Passwordserror: "", // 密码
      Confirmpasswordserror: "", // 确认密码
      VerificationCodeserror: "", //验证码
      phoneserror: "", // 手机号
      disabled: false,
      activeName: "first",
      verifyCode: "获取验证码",

      options: [
        {
          value: 0,
          label: "未选择",
        },
        {
          value: 1,
          label: "零售",
        },
        {
          value: 2,
          label: "批发",
        },
        {
          value: 3,
          label: "批零兼做",
        },
      ], // 企业类型
      scale: [
        {
          value: "10人以下",
          label: "10人以下",
        },
        {
          value: "10~20人",
          label: "10~20人",
        },
        {
          value: "20~50人",
          label: "20~50人",
        },
        {
          value: "50~100人",
          label: "50~100人",
        },
        {
          value: "100人~500人",
          label: "100人~500人",
        },
        {
          value: "500人以上",
          label: "500人以上",
        },
      ], //企业规模
      record: {
        name: "", // 企业名字
        enterprisetype: 0, // 企业类型
        enterprisescale: "10人以下", //企业规模
        trade: "", // 行业
        Contacts: "", // 联系人
        phone: "", // 手机号
        Enterprisephone: "", // 企业电话
        Enterprisescale: "", // 企业规模
        Enterpriseaddress: "", // 企业地址
        Password: "", // 密码
        Confirmpassword: "", // 确认密码
        VerificationCode: "", //验证码
      },
      handle_password: true, // 是否可以点击获取验证码按钮
    };
  },
  methods: {
    Blurphone() {
      let phoneReg =
          /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (this.type == 1) {
        if (!phoneReg.test(this.record.phone)) {
          this.phoneserror = "手机号格式不正确！";
          return;
        } else {
          this.phoneserror = "";
        }

        let params = {
          command: "1117",
          user_phone: this.record.phone,
        };
        this.request
          .post("http://118.190.210.223:10003/user.php", {
            jparams: JSON.stringify(params),
          })
          .then((res) => {
            if (res.result.accept == 1) {
              this.handle_password = false;
            }
          })
          .catch((err) => {
            // console.log(res);
          });
      } else {
        if (!phoneReg.test(this.record.phone)) {
          this.phoneserror = "手机号格式不正确！";
          return;
        } else {
          this.handle_password = false;
          this.phoneserror = "";
        }
      }
    },
    handlepassword() {
      var str = this.record.Password;
      let M = str.MD5(32); // 32位加密方法

      let params = {
        command: 1005,
        verifi_code: this.record.VerificationCode,
        user: { user_login: this.record.phone, user_pwd: M },
        // command: "1117",
        // user_phone: ,
      };
      let Password = false;
      if (this.record.Password != "") {
        if (this.record.Password === this.record.Confirmpassword) {
          this.Confirmpasswordserror = "";
          Password = true;
        } else {
          this.Confirmpasswordserror = "两次密码不一致";
          Password = false;
        }
      } else {
        this.Passwordserror = "密码不能为空";
        Password = false;
      }
      if (this.record.phone == "") {
        this.phoneserror = "手机号不能为空";
      } else {
        this.phoneserror = "";
      }
      if (this.record.VerificationCode == "") {
        this.VerificationCodeserror = "验证码不能为空";
      } else {
        this.VerificationCodeserror = "";
      }

      if (
        this.record.phone != "" &&
        Password &&
        this.record.VerificationCode != ""
      ) {
        this.request
          .post("http://118.190.210.223:10003/user.php", {
            jparams: JSON.stringify(params),
          })
          .then((res) => {
            console.log(res);

            if (res.result.accept == 1) {
              this.handle_password = true;
              this.$confirm(
                res.result.description + ", 是否前往登录?",
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                }
              )
                .then(() => {
                  this.$router.push("/");
                })
                .catch(() => {
                  this.record = {
                    name: "", // 企业名字
                    enterprisetype: 0, // 企业类型
                    enterprisescale: "10人以下", //企业规模
                    trade: "", // 行业
                    Contacts: "", // 联系人
                    phone: "", // 手机号
                    Enterprisephone: "", // 企业电话
                    Enterprisescale: "", // 企业规模
                    Enterpriseaddress: "", // 企业地址
                    Password: "", // 密码
                    Confirmpassword: "", // 确认密码
                    VerificationCode: "", //验证码
                  };
                  this.$message({
                    type: "info",
                    message: "已取消",
                  });
                });
            } else {
              this.$message({
                showClose: true,
                message: res.result.description,
                type: "warning",
                duration: 3000,
              });
            }
          })
          .catch((err) => {
            // console.log(res);
          });
      }
    },
    ahkjhkj(path) {
      window.open(path); // 去哪儿
      // window.opener()  //回哪儿
    },
    loginGoRegister() {
      this.$router.push("/"); // 跳后端首页
    },
    Blur1(val) {
      if (this.record.Confirmpassword != "") {
        if (this.record.Password == this.record.Confirmpassword) {
          // console.log("密码", val);
          this.Passwordserror = "";
          this.Confirmpasswordserror = "";
        } else {
          this.Passwordserror = "两次密码不一致";
        }
      }
      // if (
      //   this.record.Confirmpassword == this.record.Password ||
      //   this.record.Confirmpassword != ""
      // ) {
      //   console.log("密码", val);
      //   this.Passwordserror = "";
      // } else {
      //   this.Passwordserror = "两次密码不一致";
      // }
    },
    Blur(val) {
      if (this.record.Password != "") {
        if (this.record.Confirmpassword == this.record.Password) {
          this.Passwordserror = "";
          this.Confirmpasswordserror = "";
        } else {
          this.Confirmpasswordserror = "两次密码不一致";
        }
      }
      // if (
      //   this.record.Password == this.record.Confirmpassword ||
      //   this.record.Password != ""
      // ) {
      //   console.log("却人密码", val);
      //   this.Confirmpasswordserror = "";
      // } else {
      //   this.Confirmpasswordserror = "两次密码不一致";
      // }
    },
    inputValcall(data, fieldName) {
      this.record[fieldName] = data;
      // this.validatePhone()
    },
    inputValPassword(data, fieldName) {
      this.record[fieldName] = data;
    },
    validateBtn() {
      //倒计时
      let time = 60;
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer);
          this.disabled = false;
          this.verifyCode = "获取验证码";
        } else {
          this.verifyCode = time + "秒后重试";
          this.disabled = true;
          time--;
        }
      }, 1000);
      // this.request.post();
    },
    verifyCodeName() {
      if (this.handle_password) {
        this.$message({
          showClose: true,
          message: "请录入正确的手机号",
          type: "warning",
          duration: 3000,
        });
        return;
      }
      if (this.validatePhone()) {
        // if (
        //   this.record.Confirmpassword == this.record.Password &&
        //   this.record.Confirmpassword != "" &&
        //   this.record.Password != ""
        // ) {
        this.validateBtn();
        //发送网络请求
        let params = {
          command: "1112",
          hci_key: "",
          hci_result: "",
          user: { user_login: this.record.phone },
        };
        // console.log(params);
        // let jparams = JSON.stringify(params);
        // let jparams_arr = { jparams: JSON.stringify(params) };
        this.request
          .post("http://118.190.210.223:10003/user.php", {
            jparams: JSON.stringify(params),
          })
          .then((res) => {
            this.Passwordserror = "";
            // console.log(res);
          })
          .catch((err) => {
            // console.log(res);
          });
        // } else {
        //   // this.record.Confirmpassword == this.record.Password;
        //   if (this.record.Password == "") {
        //     this.Passwordserror = "密码不能为空";
        //   } else if (this.record.Confirmpassword == "") {
        //     this.Confirmpasswordserror = "请确认密码";
        //   }
        // }
      }
    },
    validatePhone() {
      //判断输入的手机号是否合法
      // console.log(this.phone);

      if (!this.record.phone) {
        this.phoneserror = "手机号不能为空";
        // return false
      } else if (!/^1\d{10}$/.test(this.record.phone)) {
        this.phoneserror = "请输入正确的手机号";
        // return false
      } else {
        this.phoneserror = "";
        return true;
      }
    },
    handleLogin() {
      if (this.record.name == "") {
        this.nameserror = "企业名字不能为空";
      } else {
        this.nameserror = "";
      }
      if (this.record.trade == "") {
        this.tradeserror = "行业不能为空";
      } else {
        this.tradeserror = "";
      }
      if (this.record.Contacts == "") {
        this.Contactsserror = "联系人不能为空";
      } else {
        this.Contactsserror = "";
      }
      let Password = false;
      if (this.record.Password != "") {
        if (this.record.Password === this.record.Confirmpassword) {
          this.Confirmpasswordserror = "";
          Password = true;
        } else {
          this.Confirmpasswordserror = "两次密码不一致";
          Password = false;
        }
      } else {
        this.Passwordserror = "密码不能为空";
        Password = false;
      }
      if (this.record.phone == "") {
        this.phoneserror = "手机号不能为空";
      } else {
        this.phoneserror = "";
      }
      if (this.record.VerificationCode == "") {
        this.VerificationCodeserror = "验证码不能为空";
      } else {
        this.VerificationCodeserror = "";
      }
      if (
        this.record.name != "" &&
        this.record.trade != "" &&
        this.record.Contacts != "" &&
        Password == true &&
        // this.record.Confirmpassword != "" &&
        this.record.phone != "" &&
        this.record.VerificationCode != ""
      ) {
        // console.log(123);

        var str = this.record.Password;
        let M = str.MD5(32); // 32位加密方法
        let params = {
          command: 1001,
          user: {
            user_login: this.record.phone, // 手机号
            user_pwd: M, // md5加密密码
            verifi_code: this.record.VerificationCode, // 验证码
            method: 2, // 注册方式
            name_ch: this.record.name, // 企业名字
            address_ch: this.record.Enterpriseaddress, // 企业地址
            industry: this.record.trade, // 行业
            type: this.record.enterprisetype, // 企业类型
            dimensions: this.record.enterprisescale, // 企业规模
            contact_name: this.record.Contacts, // 联系人
            contact_telephone: this.record.phone, // 手机号
          },
        };
        this.request
          .post("http://118.190.210.223:10003/user.php", {
            jparams: JSON.stringify(params),
          })
          .then((res) => {
            // console.log(res);
            let { result } = res;
            if (result.accept == 1) {
              // 失败
              this.$message({
                showClose: true,
                message: "注册成功正在前往登录!!!",
                type: "success",
                duration: 3000,
              });
              this.$router.push("/");
            }
            if (result.code == "APP_1_10000") {
              this.$confirm("该用户已经注册, 是否前往登录?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
                .then(() => {
                  this.$router.push("/");
                })
                .catch(() => {
                  this.$message({
                    type: "info",
                    message: "已取消",
                  });
                });
            } else {
              this.$message({
                message: result.description,
                type: "warning",
                duration: 1000,
              });
            }
          });
      }
    },
  },
  created() {
    this.type = this.$router.history.current.query.type;
    this.record = {
      name: "", // 企业名字
      enterprisetype: 0, // 企业类型
      enterprisescale: "10人以下", //企业规模
      trade: "", // 行业
      Contacts: "", // 联系人
      phone: "", // 手机号
      Enterprisephone: "", // 企业电话
      Enterprisescale: "", // 企业规模
      Enterpriseaddress: "", // 企业地址
      Password: "", // 密码
      Confirmpassword: "", // 确认密码
      VerificationCode: "", //验证码
    };
  },
};
</script>

<style lang="less">
#Record {
  width: 100%;
  height: 100%;
  // background: linear-gradient(#409EFF, #e9f1f6 50%, #409EFF);;
  background: url("../../assets/login/注册背景.jpg") no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  .Record_boxs {
    width: 101%;
    height: 100%;
    margin: 0 auto;
    overflow: auto;
  }
  .Record_box {
    width: 600px;
    height: 94.6%;
    background-color: rgba(255, 255, 255, 0.5);
    margin: 0 auto;
    padding: 50px 100px 0;
    // .passwor_dox {
    //   display: flex;
    //   span {
    //     white-space: nowrap;
    //   }
    //   .el-input--suffix .el-input__inner {
    //     height: 32px;
    //     line-height: 32px;
    //   }
    // }
    // text-align: center;
    .Record_list {
      position: relative;
      ul {
        position: absolute;
        top: 52px;
        right: 260px;
        display: flex;
        list-style: none;

        li {
          width: 82px;
          margin: 0 15px 0 0;
          color: #fff;
          cursor: pointer;

          p {
            white-space: nowrap;
            img {
              width: 17px;
              height: 17px;
            }

            span {
              display: inline-block;
            }
            a {
              color: #409eff;
              font-size: 16px;
            }
          }
        }
      }
    }
    .top {
      width: 100%;
      height: 40px;
      line-height: 40px;
      font-size: 18px;
      // background-color: #2594ff;
      text-align: center;
      position: relative;
      .top_box {
        position: absolute;
        top: 6px;
        left: 206px;
        span {
          display: inline-block;
          width: 20px;
          height: 20px;
          border: 4px solid #0383fb;
          transform: rotate(46deg);
        }
      }
      .top_box1 {
        position: absolute;
        top: 6px;
        left: 344px;
        span {
          display: inline-block;
          width: 20px;
          height: 20px;
          border: 4px solid #0383fb;
          transform: rotate(46deg);
        }
      }
    }
    .InputOne {
      //   margin: 0 auto;
      width: 500px;
      margin-top: 15px;
      margin-left: 48px;
      .input_one {
        border: 1px solid #fff;
        background-color: #fff;
      }
      .el-input__inner {
        // background-color: transparent;
        // color: #fff;
      }
    }
    .backgroundfff {
      // background-color: #fff !important;
      .el-input__inner {
        // background-color: transparent;
        // color: #fff;
      }
    }
    .InputOne_one {
      margin-top: 15px;
      margin-left: 48px;
      display: flex;

      .input_one {
        border: 1px solid #fff;
        background-color: #fff;
      }
      .InputOnes {
        // margin: 0;
        width: 378px;
        .el-input__inner {
          // background-color: transparent;
          // color: #fff;
        }
      }
      .el-button {
        padding: 7px 8px;
        margin-left: 30px;
      }
    }
    .selectbox {
      margin-left: 48px;
      width: 495px;
      height: 28px;
      // margin-top: 10px;
      margin-top: 15px;
      border: 1px solid #fff;
      background-color: #fff;
      border-radius: 5px;

      span {
        font-size: 14px;
        margin-left: 5px;
        color: #000;
        font-weight: bold;
      }
      .el-input__inner {
        text-indent: 5px;
        width: 422px;
        padding: 0;
        height: 28px;
        border: none;
        // background-color: transparent;
        // color: #fff;
      }

      .el-input__icon {
        line-height: 28px;
      }
    }

    // .selectbox:hover {
    //   border: 1px solid #2594ff;
    // }
    .clickbtn {
      width: 500px;
      margin-top: 15px;
      margin-left: 48px;
      display: flex;
      justify-content: space-between;
      position: relative;
      .el-button {
        padding: 7px 70px;
        margin-right: 3px;
      }
      a {
        color: #0383fb;
      }
    }
    .p {
      position: absolute;
      right: 0px;
      bottom: -50px;
    }
  }
  .footer {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 23px;
    background-color: #1e1e1e;
    color: #fff;
    text-align: center;
    font-size: 14px;
    line-height: 23px;
  }
  @media screen and (max-height: 600px) {
    .Record_box {
      height: 100%;
    }

    .footer {
      display: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/Views/record/record.vue